import { SidebarMenuItem } from '../../shared/ui/models/private-sidebar.types';

export const CARRIER_MENU: SidebarMenuItem[] = [
  {
    id: 'home',
    labelKey: 'private.sidebar.home',
    route: '/app/carriers',
    routeExact: true,
    materialIcon: 'home'
  },
  {
    id: 'dashboard',
    labelKey: 'private.sidebar.dashboard',
    route: '/app/carriers/dashboard',
    materialIcon: 'bar_chart'
  },
  {
    id: 'offers',
    labelKey: 'private.sidebar.offers',
    route: '/app/carriers/offers',
    materialIcon: 'article'
  },
  {
    id: 'requests',
    labelKey: 'private.sidebar.freight_requests',
    route: '/app/carriers/requests',
    materialIcon: 'search'
  },
  {
    id: 'my-shippers',
    labelKey: 'private.sidebar.my_shippers',
    route: '/app/carriers/my-shippers',
    materialIcon: 'apartment'
  },
  {
    id: 'portal',
    labelKey: 'private.sidebar.carrier_portal',
    route: '/app/portal',
    materialIcon: 'local_shipping'
  },
  {
    id: 'tutorials',
    labelKey: 'private.sidebar.tutorials',
    route: '/app/carriers/tutorials',
    materialIcon: 'school'
  },
  {
    id: 'settings',
    labelKey: 'private.sidebar.settings',
    materialIcon: 'settings',
    children: [
      {
        id: 'settings-group-profile',
        labelKey: 'private.sidebar.settings_group_profile',
        materialIcon: 'person',
        children: [
          {
            id: 'settings-profile',
            labelKey: 'private.sidebar.settings_profile',
            route: '/app/configurations-carrier/profile',
            materialIcon: 'manage_accounts'
          }
        ]
      },
      {
        id: 'settings-group-registrations',
        labelKey: 'private.sidebar.settings_group_registrations',
        materialIcon: 'list_alt',
        children: [
          {
            id: 'settings-companies',
            labelKey: 'private.sidebar.settings_companies',
            route: '/app/configurations-carrier/companies',
            materialIcon: 'business'
          }
        ]
      },
      {
        id: 'settings-group-users',
        labelKey: 'private.sidebar.settings_group_users',
        materialIcon: 'group',
        children: [
          {
            id: 'settings-users',
            labelKey: 'private.sidebar.settings_users_registration',
            route: '/app/configurations-carrier/users',
            materialIcon: 'person_add'
          },
        ]
      },
      {
        id: 'settings-group-system',
        labelKey: 'private.sidebar.settings_group_system',
        materialIcon: 'tune',
        children: [
          {
            id: 'settings-integrations',
            labelKey: 'private.sidebar.settings_integrations',
            route: '/app/configurations-carrier/integrations',
            materialIcon: 'hub'
          }
        ]
      }
    ]
  }
];
